import { AvatarCharecter, AvatarImage, TextField } from "components";
import { Camera, Eye, EyeOff } from "lucide-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { repareURL } from "utils";
interface IUserItemEdit {
    onClose: () => void;
    onConfirm?: (a: any) => void;
    item: any
}
export default function Profile({ onClose, onConfirm, item }: IUserItemEdit) {
    const {
        register,
        control,
        handleSubmit,
        setValue,
    } = useForm({ defaultValues: { root: item ?? null } });
    const imgRef = useRef<HTMLInputElement>(null)
    const [showPassword, setShowPassword] = useState({
        passwd: false,
        cfpasswd: false,
    });
    const [imagePreviews, setImagePreviews] = useState<string | null>()

    useEffect(() => {
        if (item?.avatar) {
            setValue('root.avatar', null);
        }
        if (item?.status) {
            setValue('root.status', item?.status);
        }
    }, [item]);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => setImagePreviews(reader.result as string);
            reader.readAsDataURL(file);
            setValue('root.avatar', file);
        } else {
            setImagePreviews(null);
        }
    };

    const renderAvatar = useCallback(() => imagePreviews ? (
        <img src={imagePreviews} alt="Avatar" className="w-20 h-20 rounded-[50%] border border-gray-200" />
    ) : <>
        {item.avatar ? <AvatarImage src={repareURL(item.avatar)} alt={item?.name} className="w-20 h-20 rounded-[50%] border border-gray-200" /> : <AvatarCharecter className="w-20 h-20" name={item?.name} />}
    </>, [imagePreviews, item.avatar])

    return (
        <div className="mx-auto bg-white rounded-lg ">
            <div className="flex items-center justify-center py-10">
                <div className='relative'>
                    {renderAvatar()}
                    <Camera onClick={() => imgRef.current?.click()} size={18} className='absolute bottom-0 right-0 bg-white rounded-full border border-gray-300 shadow-sm cursor-pointer p-[2px]' />
                    <input type="file" className="hidden" ref={imgRef} accept="image/*" onChange={handleImageChange} />
                </div>
            </div>
            <div className="content-modal p-4">
                <div className="grid md:grid-cols-2 gap-3 grid-cols-1">
                    <div>
                        <label className="block font-medium mb-1">Họ tên:</label>
                        <TextField
                            type="text"
                            placeholder="Nhập họ tên"
                            {...register("root.name")}
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Email:</label>
                        <TextField
                            type="email"
                            {...register("root.email")}
                            placeholder="you@example.com"
                            disabled
                            required
                        />
                    </div>
                    <div className="relative">
                        <label className="block font-medium mb-1">Mật khẩu:</label>
                        <TextField
                            type={showPassword.passwd ? 'text' : 'password'}
                            {...register("root.password")}
                            placeholder="Nhập mật khẩu"
                            className="relative"
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(s => ({ ...s, passwd: !showPassword.passwd }))}
                            className="absolute right-3 top-2/3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword.passwd ? <EyeOff size={20} /> : <Eye size={20} />}
                        </button>
                    </div>

                </div>
            </div>
            <div className="flex justify-center gap-2 p-4 my-5">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
